import React from 'react';
import ReactExport from 'react-data-export';
import ExcelButton from './ExcelButton';
import { prepareJoiningDataset } from '../functions/community-operations';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ExcelExport extends React.Component {
  render() {
    const { dataSet } = this.props;
    let data = null;
    if (dataSet) data = prepareJoiningDataset(dataSet);

    return <ExcelFile element={<ExcelButton />}>{data && <ExcelSheet dataSet={data} name="приєднані ТГ" />}</ExcelFile>;
  }
}

export default ExcelExport;
